var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.donutData.length)?_c('donut-chart',{staticClass:"donut-chart",attrs:{"id":`donut${_vm.chartId}`,"data":_vm.donutData,"colors":_vm.colors,"resize":"true","formatter":_vm.valueFormatter}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }